function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/dashboard";
const ROOT_APPS = "/apps";
const ROOTS_PAGES = "/";
const ROOTS_PROJECTS = "/projects";
const ROOTS_ORDERS = "/orders";
const ROOTS_INVOICES = "/invoices";
const ROOTS_TASKS = "/tasks";
const ROOTS_CALENDAR = "/calendar";
const ROOTS_AUTH = "/authentication";
const ROOTS_ERRORS = "/error";
const ROOTS_CHANGELOG = "/changelog";
const ROOTS_AUTH_PROVIDERS = "/authProviders";

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  default: path(ROOTS_DASHBOARD, "/default"),
  analytics: path(ROOTS_DASHBOARD, "/analytics"),
  saas: path(ROOTS_DASHBOARD, "/saas"),
};

export const PATH_APPS = {
  root: ROOT_APPS,
  calendar: path(ROOT_APPS, "/calendar"),
  chat: path(ROOT_APPS, "/chat"),
  invoices: {
    root: path(ROOT_APPS, ROOTS_INVOICES),
    upload: {
      missing: path(ROOT_APPS, ROOTS_INVOICES + "/upload/missing"),
      historical: path(ROOT_APPS, ROOTS_INVOICES + "/upload/historical"),
    },
    missing: path(ROOT_APPS, ROOTS_INVOICES + "/missing"),
    past: path(ROOT_APPS, ROOTS_INVOICES + "/past"),
    historical: path(ROOT_APPS, ROOTS_INVOICES + "/historical"),
    all: path(ROOT_APPS, ROOTS_INVOICES + "/list"),
    sample: path(ROOT_APPS, ROOTS_INVOICES + `/details/`),
    invoice_details: (id: string): string =>
      path(ROOT_APPS, ROOTS_INVOICES + `/details/${id}`),
  },
  orders: path(ROOT_APPS, "/orders"),
  profile: {
    root: path(ROOT_APPS, "/profile"),
    personal: path(ROOT_APPS, "/profile/personal"),
    security: path(ROOT_APPS, "/profile/security"),
    credentials: path(ROOT_APPS, "/profile/credentials"),
    statistics: path(ROOT_APPS, "/profile/statistics"),
  },
  projects: path(ROOT_APPS, "/projects"),
  settings: {
    root: path(ROOT_APPS, "/settings"),
    spApi: path(ROOT_APPS, "/settings/sp-api"),
    marketplace: path(ROOT_APPS, "/settings/marketplace"),
    invoices: path(ROOT_APPS, "/settings/invoices"),
    notifications: path(ROOT_APPS, "/settings/notifications"),
    business: path(ROOT_APPS, "/settings/business"),
    billing: path(ROOT_APPS, "/settings/billing"),
  },
  tasks: path(ROOT_APPS, "/tasks"),
  fileManager: path(ROOT_APPS, "/file-manager"),
  analytics: path(ROOT_APPS, "/analytics"),
};
// routes/index.ts


export const PATH_PAGES = {
  root: ROOTS_PAGES,
  about: path(ROOTS_PAGES, "about"),
  contact: path(ROOTS_PAGES, "contact-us"),
  services: path(ROOTS_PAGES, "services"),
  terms: path(ROOTS_PAGES, "terms-service"),
  support: path(ROOTS_PAGES, "support"),
  privacy: path(ROOTS_PAGES, "privacy-policy"),
  addp: path(ROOTS_PAGES, "amazon-data-protection-policy"),
  paymentSuccess: path(ROOTS_PAGES, "payment-success"),
  paymentCancelled: path(ROOTS_PAGES, "payment-cancelled"),
};


export const PATH_PROJECTS = {
  root: ROOTS_PROJECTS,
};

export const PATH_ORDERS = {
  root: ROOTS_ORDERS,
};

export const PATH_INVOICES = {
  root: ROOTS_INVOICES,
  invoices: {
    all: path(ROOTS_INVOICES, "/list"),
    sample: path(ROOTS_INVOICES, `/details/`),
    invoice_details: (id: string): string =>
      path(ROOTS_INVOICES, `/details/${id}`),
  },
};

export const PATH_TASKS = {
  root: ROOTS_TASKS,
};

export const PATH_CALENDAR = {
  root: ROOTS_CALENDAR,
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  signin: path(ROOTS_AUTH, "/signin"),
  signup: path(ROOTS_AUTH, "/signup"),
  passwordReset: path(ROOTS_AUTH, "/password-reset"),
  forgetPassword: path(ROOTS_AUTH, "/forget-password"),
  otpVerify: path(ROOTS_AUTH, "/otp-verify"),
  ssoSuccess: path(ROOTS_AUTH, "/sso-success"),
  clerk: path(ROOTS_AUTH, "/clerk"),
  auth0: path(ROOTS_AUTH, "/auth0"),
};


export const PATH_START = {
  root: "https://mantine-analytics-dashboard-docs.netlify.app/getting-started",
};

export const PATH_DOCS = {
  root: "https://mantine-analytics-dashboard-docs.netlify.app/",
};

export const PATH_CHANGELOG = {
  root: ROOTS_CHANGELOG,
};

export const PATH_GITHUB = {
  org: "https://github.com/design-sparx",
  repo: "https://github.com/design-sparx/mantine-analytics-dashboard",
};

export const PATH_AUTH_PROVIDERS = {
  root: ROOTS_AUTH_PROVIDERS,
  clerk: path(ROOTS_AUTH_PROVIDERS, "/clerk"),
  auth0: path(ROOTS_AUTH_PROVIDERS, "/auth0"),
};
